const tracking = {
  get_device_list: "/api/device",
  update_device_details: "/api/device/${data.DeviceID}",
  get_decvice_settings: "/api/device/settings",
  get_device_overview: "/api/device/stats/${data.duration}",
  get_journeys: "/api/device/journeys/${data.device_id}",
  get_messages: "/api/device/messages/${data.device_id}",
  get_location_data: "/api/location",
  get_location_stats: "/api/location/stats",
  get_LocationCategory: "/api/location/category",
  get_possible_pois: "/api/location/possible_pois",
  get_devices_back_online: "/api/device/backonline",
  add_new_poi: "/api/location",
  get_watchlisted_locations: "/api/watchlist/location",
  get_location_details: "/api/location/${data.locationId}",
  update_location_details: "/api/location/${data.LocationID}",
  fetch_devices_at_POI: "/api/location/devices/${data.id}",
  delete_from_watchlist_location: "/api/watchlist/location/${data.id}",
  add_to_watchlist_location: "/api/watchlist/location",
  get_assests_stats: "/api/location/arrive_stats/${data.locationId}/${data.week}",
  get_cycle_data:
    "/api/location/cycle/stats?category=Plant&num_weeks=${data.duration}&start_location_id=${data.locationId}&include_midcycle=${data.includeMidCycle}",
  fetchCycleDetails:
    "/api/location/cycle/detail?device_id=${data.DeviceID}&start_date=${data.startDate}&end_date=${data.endDate}",
  get_cycle_stats:
    "/api/location/cycle/history?category=Plant&num_weeks=${data.duration}&start_location_id=${data.locationId}&include_midcycle=${data.includeMidCycle}",
  fetchCycleChartData: "/api/location/cycle/donut?num_weeks=${data.cycleDuration}&start_location_id=${data.locationId}",
  get_journeys_data: "/api/journey/1",
  get_journey_device_data: "/api/journey/devices/${data.originId}/${data.destinationId}/${data.weeks}",
  add_to_watchlist_journeys: "/api/watchlist/journey",
  delete_from_watchlist_journeys: "/api/watchlist/journey",
  get_report_data: "/api/report/1/24",
  get_alerts_data: "/api/alert",
  get_active_alerts: "/api/alert/active",
  add_alert: "/api/alert",
  update_alert: "/api/alert/${data.id}",
  delete_alert: "/api/alert/${data.id}",
  get_recipients_list: "/api/alert/recipients/${data.id}",
  add_recipient: "/api/alert/recipients/${data.id}",
  delete_recipient: "/api/alert/recipients/${data.alert_id}/${data.recipient_id}",
  get_report_list: "/api/report/schedule",
  add_report: "/api/report",
  update_report: "/api/report/schedule/${data.id}",
  delete_report: "/api/report/schedule/${data.id}",
  get_report_recipients_list: "/api/report/recipients/${data.id}",
  get_report_schedule: "/api/report/schedule/${data.id}",
  add_report_recipient: "/api/report/recipients/${data.id}",
  delete_report_recipient: "/api/report/recipients/${data.report_id}/${data.recipient_id}",
  delete_tracking_device: "/api/device/${data.id}",
};

export { tracking };
